import styled from 'styled-components';

interface IColorStatusGuideProps {
  color: string;
}
export const ColorContainer = styled.div<IColorStatusGuideProps>`
  height: 20px;
  width: 60px;
  border-radius: 4px;
  background: ${(props) => props.color};
`;
